module.exports = __webpack_public_path__ + "static/media/item_6_13_comp.2654191b.png";